<template>
  <div>
    <div class="search-result-container">
      <ul v-if="!loading && !textMessage">
        <li
          class="mt-4"
          v-for="(searchResult, index) in searchResults"
          :key="index"
        >
          <a
            class="secondary-text"
            :href="searchResult.links.published_url"
            target="_blank"
            >{{ searchResult.title }}</a
          >
        </li>
      </ul>
      <div v-else-if="textMessage">
        <h3>{{ textMessage }}</h3>
      </div>
      <div v-else>
        <HelpLoader />
      </div>
    </div>
    <v-row no-gutters class="align-items-center" v-if="searchResults.length">
      <v-col sm="6">
        <label class="bold results" v-if="!loading">
          Showing {{ !((pageNumber - 1) * pageSize)? '1' :  ((pageNumber - 1) * pageSize)}} - {{ (pageNumber - 1) * pageSize + searchResults.length }} of
          {{ numberINString(searchMeta.total_entries) }} records
        </label>
      </v-col>
      <v-col sm="6">
        <Pagination
          @pageChanged="changePage($event)"
          :recordsPerPage="pageSize"
          :totalRecords="searchMeta.total_entries"
          :pageNumber="pageNumber"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import HelpLoader from '@/components/HelpLoader';
import Pagination from '@/components/Discovery/Widgets/Pagination';
import { numberINString } from '@/helpers/common';
export default {
  name: 'HelpResults',
  props: [
    'loading',
    'textMessage',
    'searchResults',
    'pageNumber',
    'pageSize',
    'searchMeta',
  ],
  data() {
      return {
          numberINString,
      };
  },
  components: {Pagination, HelpLoader},
  methods: {
    changePage(changedPage) {
      this.$emit('changePage',changedPage);
    },
  },
};
</script>
<style scoped>
.search-result-container ul {
  list-style-type: circle;
}
.search-result-container {
  margin-top: 16px;
  margin-bottom: 16px;
}
/* results */
.results {
  color: #58e2c2;
  font-weight: bold;
  font-size: 12px;
}
</style>